







































import Vue from "vue";
import { Component, Inject, Provide } from "vue-property-decorator";
import { ANIMATION_CREATE, ANIMATION_EDIT } from "@/route-names";
import AnimationResponse from "@/api/dataSource/api/Spirit/Admin/Interfaces/Models/AnimationService/AnimationResponse";
import EventBus from "@models/eventBus";

@Component
export default class PageAnimationComponent extends Vue {
  @Inject("eventBus") eventBus: EventBus;
  animationCreateRouteName = ANIMATION_CREATE;
  animationEditRouteName = ANIMATION_EDIT;
  columnNames = ["#", "Превью", "Название", "", ""];
  getDataFunc = this.$api.AnimationService.getAnimationsAsync.bind(
    this.$api.AnimationService
  );
  removeFunc = this.$api.AnimationService.deleteAnimationAsync.bind(
    this.$api.AnimationService
  );
  async created() {}
  startDelete(item: AnimationResponse) {
    this.eventBus.deleteEntity.trigger({ id: item.Id });
  }
}
